import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import creditApplication from '../../assets/forms/credit-application.pdf'
import lessorDatasheet from '../../assets/forms/lessor-datasheet.pdf'

import './style/index.css'
import './style/header-footer.css'
import './style/fa/css/fa.css'

const Header = () => (
  <div className='header'>
    <div className='logo'>
      <i className='fa fa-globe' aria-hidden='true' />
      <Link className='logo-link' to='/'> Leasing Solutions LLC</Link>
    </div>
    <div className='nav'>
      <Link className='header-link' to='/services'>Services</Link>
      <Link className='header-link' to='/experience'>Experience</Link>
      <Link className='header-link' to='/why'>Why Lease</Link>
      <Link className='header-link' to='/links'>Links</Link>
      <Link className='header-link' to='/contact'>Contact</Link>
      <span className='forms-wrap'>
        <form className='download-btn-form' method='get' action={lessorDatasheet}>
          <button type='submit' className='download-btn'>Lessor Datasheet</button>
        </form>
        <form className='download-btn-form' method='get' action={creditApplication}>
          <button type='submit' className='download-btn'>Credit Application</button>
        </form>
      </span>
    </div>
  </div>
)

const Footer = () => (
  <div className='footer'>
    <div className='section-wrap'>
      <div className='left'>
        <div className='company-info'>
          <div className='name'>&copy; Leasing Solutions LLC. All Rights Reserved.</div>
          <div className='address'>755 Route 340 Palisades, New York</div>
          <div className='contact-info'>
            <div className='contact-info-desktop'>
              <a className='contact-link' href='tel:+1-845-362-6106'>845.362.6106</a> | <a className='contact-link' href='mailto:sgeller@leasingsolutionsllc.com'>sgeller@leasingsolutionsllc.com</a>
            </div>
            <div className='contact-info-mobile'>
              <a className='contact-link' href='tel:+1-845-362-6106'>845.362.6106</a>
              <a className='contact-link' href='mailto:sgeller@leasingsolutionsllc.com'>sgeller@leasingsolutionsllc.com</a>
            </div>
          </div>
        </div>
      </div>
      <div className='right'>
        <div className='nav'>
          <span className='links-wrap'>
            <Link className='footer-link' to='/experience'>About</Link>
            <Link className='footer-link' to='/contact'>Contact</Link>
            <Link className='footer-link' to='/services'>Services</Link>
            <Link className='footer-link' to='/sitemap'>Sitemap</Link>
          </span>
          <form className='get-funding-form' method='get' action={creditApplication}>
            <button type='submit' className='get-funding'>Get Me Funding</button>
          </form>
        </div>
      </div>
    </div>
  </div>
)

const TemplateWrapper = ({children}) => (
  <div className='app'>
    <Header />
    {children()}
    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js